export default __webpack_public_path__ + "static/media/DOGE-white.fc807122.svg";